import ConfirmationModal from "./ConfirmationModal";

const strings = {
  networkError: "Error",
  networkWarning: "Warning",
  closeModal: "Close Modal",
  close: "Close",
};

type Props = {
  status: number | undefined;
  message: string | undefined;
  onRequestClose: () => void;
};
const NetworkModal = ({ status, message, onRequestClose }: Props) => {
  const isSuccessWarning = Math.floor((status ?? 400) / 100) === 2;
  return (
    <ConfirmationModal
      isOpen={!!message}
      title={isSuccessWarning ? strings.networkWarning : strings.networkError}
      message={message}
      onRequestClose={onRequestClose}
      cancelText={strings.close}
    />
  );
};
export default NetworkModal;
